import yaml from 'js-yaml';

export type MonitoringConfigDoc = Record<string, unknown>;

export function parseMonitoringYaml(content: string): MonitoringConfigDoc {
  const parsed = yaml.load(content);
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    throw new Error('Monitoring YAML must be a mapping at the root');
  }
  return parsed as MonitoringConfigDoc;
}

export function monitoringDocToYaml(doc: MonitoringConfigDoc): string {
  return yaml.dump(doc, { lineWidth: 120, noRefs: true, skipInvalid: true });
}

export {
  cloneDoc,
  ensureObject,
  asString,
  asBool,
  asNumber,
  objectRecord,
  objectMap,
} from './tenant-config-form-utils';
